import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getApprovalListIdApi = (data) => {
  return httpService({
    url: contextPath + '/spider/search/examine',
    method: 'post',
    data
  })
}

export const changeSiteStatusApi = (data) => {
  return httpService({
    url: contextPath + '/spider/examine',
    method: 'put',
    data
  })
}

export const deleteSiteApi = (data) => {
  return httpService({
    url: contextPath + '/spider/del',
    method: 'post',
    data
  })
}

export const getApprovalMeNewsListApi = (data) => {
  return httpService({
    url: contextPath + '/spider/apply/info',
    method: 'post',
    data
  })
}

export const getApprovalMeNoNewsListApi = (data) => {
  return httpService({
    url: contextPath + '/spider/api/apply/info',
    method: 'post',
    data
  })
}

// 批量审批：
export const handApprovalBatchApi = (data) => {
  return httpService({
    url: contextPath + '/spider/batch/examine',
    method: 'put',
    data
  })
}

// 已删除情况下的批量删除：
export const delApprovalBatchApi = (data) => {
  return httpService({
    url: contextPath + '/spider/del/list',
    method: 'post',
    data
  })
}
